import { render, staticRenderFns } from "./AuthorDetails.vue?vue&type=template&id=73b6f872&scoped=true&"
import script from "./AuthorDetails.vue?vue&type=script&lang=js&"
export * from "./AuthorDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuthorDetails.vue?vue&type=style&index=0&id=73b6f872&lang=less&scoped=true&"
import style1 from "./AuthorDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6f872",
  null
  
)

export default component.exports